import { render } from "./Episodes.vue?vue&type=template&id=8ca556b6"
import script from "./Episodes.vue?vue&type=script&lang=js"
export * from "./Episodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__